import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector, connect } from "react-redux";
import {
  TextField,
  Button,
  Modal,
  makeStyles,
  Snackbar,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
} from "@material-ui/core";
import { Alert as SnackbarAlert } from "@material-ui/lab";
import { DataGrid } from "@mui/x-data-grid";
import { Typography } from "@mui/material";
import {
  Alert,
  Modal as ReactstrapModal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import DeleteIcon from "@material-ui/icons/Delete";

import {
  getResourceGroups,
  addResourceGroup,
  editResourceGroup,
  deleteResourceGroup,
  clearAllResourceGroupMessages,
  // getListOfAccts,
  getListOfOrgsAndAccts,
} from "../../store/actions";
import accessToken from "../../helpers/jwt-token-access/accessToken";
import jwtDecode from "jwt-decode";
import spinner from "../../assets/images/aws/loadingGif.gif";
import getUserRole from "../../helpers/jwt-token-access/userRole";

const allowedRoles = ["Administrator"];

const isExcludedAccount = (accountNumber) =>
  !accountNumber ||
  String(accountNumber).includes("INIT00000001") ||
  String(accountNumber).includes("TEST");

const accountBelongsToResourceGroup = (account, resourceGroupName) => {
  const groups = account?.accountResourceGroups;
  if (!Array.isArray(groups) || !resourceGroupName) return false;
  return groups.some(
    (rg) =>
      rg === resourceGroupName ||
      rg?.resourcename === resourceGroupName
  );
};

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#193a6f",
  },
  activeButton: {
    color: "white", // change this to the desired active color
    marginLeft: "auto", // This will push the link to the right
    textDecoration: "none", // Remove text decoration from the link
  },
  logo: {
    maxWidth: 160,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  primary: {
    backgroundColor: "#193A6F",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#303F9F",
    },
  },
}));

const ResourceGroupsConfig = (props) => {
  const dispatch = useDispatch();
  const { accounts, organizations } = useSelector((state) => {
    console.log("--== state.orgAccount ", state.orgAccount);
    const { accounts, organizations } = state.orgAccount;
    return {
      accounts,
      organizations:
        organizations && organizations.length > 0 ? organizations[0] : {},
    };
  });

  const token = accessToken();
  const decoded = jwtDecode(token);
  const userName = decoded["email"];
  const userRole = getUserRole();

  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);

  const [resourceGroupName, setResourceGroupName] = useState("");
  const [oldResourceGroupName, setOldResourceGroupName] = useState("");
  const [resourceGroupDescription, setResourceGroupDescription] = useState("");
  const [resourceGroupToDelete, setResourceGroupToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [accountsModalOpen, setAccountsModalOpen] = useState(false);
  const [accountsModalTitle, setAccountsModalTitle] = useState("");
  const [accountsModalList, setAccountsModalList] = useState([]);

  const [deleteResourceGroupError, setDeleteResourceGroupError] =
    useState(null);

  const classes = useStyles();

  const getAccountsForResourceGroup = useCallback(
    (resourceGroupName) => {
      if (!Array.isArray(accounts) || !resourceGroupName) return [];
      return accounts.filter(
        (acct) =>
          !isExcludedAccount(acct?.accountNumber) &&
          accountBelongsToResourceGroup(acct, resourceGroupName)
      );
    },
    [accounts]
  );

  const openAccountsModal = (resourceGroupName) => {
    const rgAccounts = getAccountsForResourceGroup(resourceGroupName);
    setAccountsModalTitle(resourceGroupName);
    setAccountsModalList(rgAccounts);
    setAccountsModalOpen(true);
  };

  const closeAccountsModal = () => {
    setAccountsModalOpen(false);
    setAccountsModalTitle("");
    setAccountsModalList([]);
  };

  const clearState = () => {
    setResourceGroupName("");
    setResourceGroupDescription("");
    setOldResourceGroupName("");
    setDeleteResourceGroupError(null);
  };

  const handleAddDialogClose = () => {
    clearState();
    props.clearAllMessages();
    setAddDialogOpen(false);
  };

  // const handleEditDialogClose = () => {
  //   clearState();
  //   props.clearAllMessages();
  //   setEditDialogOpen(false);
  // };

  // const handleEdit = (row) => {
  //   // console.log("Editing resource group with row: ", row);
  //   setResourceGroupName(row.resourcename);
  //   setOldResourceGroupName(row.resourcename);
  //   setResourceGroupDescription(row.description);
  //   setEditDialogOpen(true);
  // };

  const openDeleteModal = (params) => {
    console.log("Params :: ", params);
    console.log("Organization  :: ", organizations.orgcode);
    setResourceGroupToDelete(params.resourcename);
    setShowDeleteModal(true);    
  };

  const columns = [
    { field: "resourcename", headerName: "Resource Group Name", width: 180 },
    {
      field: "description",
      headerName: "Resource Group Description",
      width: 300,
    },
    {
      field: "accounts",
      headerName: "Accounts",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        const count = getAccountsForResourceGroup(params.row.resourcename)
          .length;
        return (
          <button
            type="button"
            className="btn btn-link mr-3 text-darkblue"
            disabled={count === 0}
            onClick={() => openAccountsModal(params.row.resourcename)}
            style={{
              border: "none",
              background: "transparent",
              padding: 0,
              cursor: count > 0 ? "pointer" : "default",
            }}
          >
            <div className="badge badge-pill badge-light">{count}</div>
          </button>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => (
        <div>
          <IconButton
            aria-label="delete"
            onClick={() => openDeleteModal(params.row)}
            className={allowedRoles.includes(userRole) ? "text-danger" : ""}
            disabled={!allowedRoles.includes(userRole)}
          >
            <DeleteIcon />
          </IconButton>
        </div>
      ),
    },
  ];

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setResourceGroupToDelete(null);
    setDeleteResourceGroupError(null);
    if (props.deleteResourceGroupMessage || props.deleteResourceGroupError) {
      props.clearAllMessages();
    }
  };

  const handleDeleteConfirm = () => {
    if (resourceGroupToDelete) {
      props.deleteResourceGroup(resourceGroupToDelete, organizations?.orgcode);
    }
  };

  //For Submitting data of Add resource to API
  const handleAddSubmit = (e) => {
    e.preventDefault();
    console.log("Submitting Add Resource Group Form");

    let resourceGroup = {
      resourceGroup: resourceGroupName,
      description: resourceGroupDescription,
      orgCode: organizations?.orgcode,
    };
    console.log("Submitting data ::", resourceGroup);
    props.addResourceGroup(resourceGroup);
  };

  //For Submitting data of Edit resource to API
  // const handleEditSubmit = (e) => {
  //   e.preventDefault();
  //   console.log("Submitting Edit Resource Group Form");

  //   let resourceGroup = {
  //     oldResourceGroupName: oldResourceGroupName,
  //     newResourceGroupName: resourceGroupName,
  //     description: resourceGroupDescription,
  //     orgCode: organizations?.orgcode,
  //   };
  //   console.log("Submitting data ::", resourceGroup);
  //   props.editResourceGroup(resourceGroup);
  // };


  // const closeEditModal = useCallback(() => {
  //   handleEditDialogClose();
  // }, []);
  const closeDeleteModalCached = useCallback(() => {
    closeDeleteModal();
  }, []);
  const clearAllMessages = useCallback(() => {
    props.clearAllMessages();
  }, []);

  const getResourceGroups = useCallback(() => {
    props.getResourceGroups();
  }, []);

  const getListOfOrgsAndAccts = useCallback(() => {
    props.getListOfOrgsAndAccts();
  }, []);

  const getMsg = props.getResourceGroupsMessage;
  const getErr = props.getResourceGroupsError;
  const editMsg = props.editResourceGroupMessage;
  const deleteMsg = props.deleteResourceGroupMessage;
  const deleteErr = props.deleteResourceGroupError;
  const addMsg = props.addResourceGroupMessage;

  useEffect(() => {
    // dispatch(getListOfAccts());
    getListOfOrgsAndAccts();
  }, [getListOfOrgsAndAccts]);

  useEffect(() => {
    console.log("~ Calling getResourceGroups()");
    // if (userRole.includes("Administrator")) {
    getResourceGroups();
    // }
  }, [getResourceGroups]);

  // Close Add Resource Group dialog automatically
  useEffect(() => {
    console.log("useEffect for closing add resource group dialog");
    if (addMsg) {
      // Add successful, close the dialog box
      setAddDialogOpen(false);
      clearState();
      getResourceGroups();
      // props.getListOfAccts();
      getListOfOrgsAndAccts();
    }
  }, [addMsg, getResourceGroups, getListOfOrgsAndAccts]);

  // useEffect(() => {
  //   if (editMsg) {
  //     closeEditModal();
  //   }
  // }, [closeEditModal, editMsg]);
  useEffect(() => {
    if (deleteMsg) {
      getListOfOrgsAndAccts();
      closeDeleteModalCached();
    }
    if (deleteErr) {
      setDeleteResourceGroupError(deleteErr);
    }
  }, [closeDeleteModalCached, deleteMsg, deleteErr, getListOfOrgsAndAccts]);
  useEffect(() => {
    if (getMsg || getErr) {
      setTimeout(() => {
        clearAllMessages();
      }, 5000);
    }
  }, [clearAllMessages, getMsg, getErr]);

  return (
    <div>
      <h1>Resource Groups Configuration</h1>
      {
        // userRole.includes("Administrator")
        true ? (
          <div
            style={{
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Button
              variant="contained"
              className={classes.primary}
              style={{ margin: "10px 10px", alignSelf: "flex-start" }}
              onClick={() => setAddDialogOpen(true)}
              disabled={
                !allowedRoles.includes(userRole) || props.isAddingResourceGroup
              }
            >
              Add Resource Group
            </Button>

            {/* Data grid to display users */}
            <div>
              {props.isGettingResourceGroups && (
                <>
                  <div
                    style={{
                      display: "flex",
                      direction: "row",
                      alignContent: "center",
                      alignItems: "center",
                      justifyContent: "center",
                      justifyItems: "center",
                      height: "100vh",
                    }}
                  >
                    <img src={spinner} width="32px" alt="Spinner" />
                  </div>
                </>
              )}
              {props.getResourceGroupsMessage && (
                <Snackbar
                  open={props.getResourceGroupsMessage !== null}
                  autoHideDuration={5000}
                >
                  <SnackbarAlert severity="success">
                    {props.getResourceGroupsMessage}
                  </SnackbarAlert>
                </Snackbar>
              )}
              {props.getResourceGroupsError && (
                <Snackbar
                  open={props.getResourceGroupsError !== null}
                  autoHideDuration={5000}
                >
                  <SnackbarAlert severity="error">
                    {props.getResourceGroupsError}
                  </SnackbarAlert>
                </Snackbar>
              )}
              {props.deleteResourceGroupMessage && (
                <Snackbar
                  open={props.deleteResourceGroupMessage !== null}
                  autoHideDuration={5000}
                >
                  <SnackbarAlert severity="success">
                    {props.deleteResourceGroupMessage}
                  </SnackbarAlert>
                </Snackbar>
              )}
              {props.addResourceGroupMessage && (
                <Snackbar
                  open={props.addResourceGroupMessage !== null}
                  autoHideDuration={5000}
                >
                  <SnackbarAlert severity="success">
                    Resource Group Added Successfully!
                  </SnackbarAlert>
                </Snackbar>
              )}
              {props.editResourceGroupMessage && (
                <Snackbar
                  open={props.editResourceGroupMessage !== null}
                  autoHideDuration={5000}
                >
                  <SnackbarAlert severity="success">
                    {props.editResourceGroupMessage}
                  </SnackbarAlert>
                </Snackbar>
              )}
              {props.resourceGroups && (
                <DataGrid
                  columns={columns}
                  rows={props.resourceGroups.filter(
                    (row) =>
                      row && typeof row === "object" && row.resourcename
                  )}
                  getRowId={(row) => row.resourcename}
                  autoHeight
                />
              )}
            </div>

            {/* Modal: accounts linked to a resource group — matches Update Account dialog chrome */}
            <ReactstrapModal
              isOpen={accountsModalOpen}
              size="lg"
              centered
              toggle={closeAccountsModal}
            >
              <ModalHeader
                toggle={closeAccountsModal}
                style={{
                  backgroundColor: "#F98125",
                  margin: -1,
                  display: "flex",
                  alignItems: "center",
                  minHeight: 56,
                }}
                close={
                  <button
                    type="button"
                    aria-label="Close"
                    onClick={closeAccountsModal}
                    style={{
                      padding: 0,
                      margin: 0,
                      border: "none",
                      background: "transparent",
                      color: "#FFFFFF",
                      fontSize: 28,
                      fontWeight: 700,
                      lineHeight: 1,
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      opacity: 1,
                      boxShadow: "none",
                    }}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                }
              >
                <Typography color="#FFFFFF" variant="h6">
                  Accounts — {accountsModalTitle}
                </Typography>
              </ModalHeader>
              <ModalBody
                style={{
                  maxHeight: "calc(100vh - 120px)",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                {accountsModalList.length === 0 ? (
                  <p style={{ margin: 0 }}>
                    No accounts associated with this resource group.
                  </p>
                ) : (
                  <TableContainer component={Paper} variant="outlined">
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            style={{
                              backgroundColor: "#6c757d",
                              color: "#FFFFFF",
                              fontWeight: 700,
                            }}
                          >
                            Account Name
                          </TableCell>
                          <TableCell
                            style={{
                              backgroundColor: "#6c757d",
                              color: "#FFFFFF",
                              fontWeight: 700,
                            }}
                          >
                            Account Number
                          </TableCell>
                          <TableCell
                            style={{
                              backgroundColor: "#6c757d",
                              color: "#FFFFFF",
                              fontWeight: 700,
                            }}
                          >
                            Account Type
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {accountsModalList.map((acct) => (
                          <TableRow
                            key={acct.accountNumber || acct.accountCode}
                          >
                            <TableCell>{acct.accountName || "—"}</TableCell>
                            <TableCell>{acct.accountNumber || "—"}</TableCell>
                            <TableCell>
                              {acct.accountType || acct.accounttype || "—"}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
                <hr
                  style={{
                    backgroundColor: "rgba(0, 0, 0, 0.1)",
                    width: "100%",
                    marginTop: 20,
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    marginTop: "10px",
                    gap: "10px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <button
                    type="button"
                    className="btn w-lg btn-secondary"
                    onClick={closeAccountsModal}
                  >
                    Close
                  </button>
                </div>
              </ModalBody>
            </ReactstrapModal>

            {/* Modal to add a resource group — matches Update Account dialog chrome */}
            <ReactstrapModal
              isOpen={addDialogOpen}
              size="lg"
              centered
              toggle={handleAddDialogClose}
            >
              <ModalHeader
                toggle={handleAddDialogClose}
                style={{
                  backgroundColor: "#F98125",
                  margin: -1,
                  display: "flex",
                  alignItems: "center",
                  minHeight: 56,
                }}
                close={
                  <button
                    type="button"
                    aria-label="Close"
                    onClick={handleAddDialogClose}
                    style={{
                      padding: 0,
                      margin: 0,
                      border: "none",
                      background: "transparent",
                      color: "#FFFFFF",
                      fontSize: 28,
                      fontWeight: 700,
                      lineHeight: 1,
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      opacity: 1,
                      boxShadow: "none",
                    }}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                }
              >
                <Typography color="#FFFFFF" variant="h6">
                  Add Resource Group
                </Typography>
              </ModalHeader>
              <ModalBody
                style={{
                  maxHeight: "calc(100vh - 120px)",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                {props.isAddingResourceGroup && (
                  <img src={spinner} width="32px" alt="Spinner" />
                )}
                {props.addResourceGroupError && (
                  <Alert className="mt-3 mb-0" color="danger">
                    Error while adding a resource group.
                    {JSON.stringify(props.addResourceGroupError)}
                  </Alert>
                )}
                <form className={classes.form} onSubmit={handleAddSubmit}>
                  <div>
                    <TextField
                      label="Resource Group Name"
                      size="small"
                      fullWidth
                      value={resourceGroupName}
                      onChange={(e) => {
                        setResourceGroupName(e.target.value);
                      }}
                    />
                  </div>
                  <br />
                  <div>
                    <TextField
                      label="Resource Group Description"
                      size="small"
                      fullWidth
                      value={resourceGroupDescription}
                      onChange={(e) => {
                        setResourceGroupDescription(e.target.value);
                      }}
                    />
                  </div>
                  <hr
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.1)",
                      width: "100%",
                      marginTop: 20,
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      marginTop: "10px",
                      gap: "10px",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <button
                      type="button"
                      className="btn w-lg btn-secondary"
                      onClick={handleAddDialogClose}
                      disabled={props.isAddingResourceGroup}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn w-lg btn-primary text-light"
                      disabled={props.isAddingResourceGroup}
                    >
                      {props.isAddingResourceGroup
                        ? "Loading ..."
                        : "Add Resource Group"}
                    </button>
                  </div>
                </form>
              </ModalBody>
            </ReactstrapModal>

            {/* Modal to edit a resource group */}
            {/* <Modal
              className={classes.modal}
              open={editDialogOpen}
              onClose={handleEditDialogClose}
            >
              <div className={classes.paper}>
                <h2 id="simple-modal-title">Edit Resource Group</h2>
                {props.isEditingResourceGroup && (
                  <img src={spinner} width="32px" alt="Spinner" />
                )}
                {props.editResourceGroupError && (
                  <Alert className="mt-3 mb-0" color="danger">
                    Error while editing a resource group.
                    {JSON.stringify(props.editResourceGroupError)}
                  </Alert>
                )}
                <br />
                <br />
                <form className={classes.form} onSubmit={handleEditSubmit}>
                  <div>
                    <TextField
                      label="Resource Group Name"
                      size="small"
                      fullWidth
                      value={resourceGroupName}
                      onChange={(e) => {
                        setResourceGroupName(e.target.value);
                      }}
                    />
                  </div>
                  <br />
                  <div>
                    <TextField
                      label="Resource Group Description"
                      size="small"
                      fullWidth
                      value={resourceGroupDescription}
                      onChange={(e) => {
                        setResourceGroupDescription(e.target.value);
                      }}
                    />
                  </div>
                  <Button
                    type="submit"
                    // fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    // onClick={handleAddUser}
                    disabled={props.isEditingResourceGroup}
                  >
                    Edit Resource Group
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => handleEditDialogClose()}
                    style={{ margin: "10px 10px", alignSelf: "flex-start" }}
                  >
                    Cancel
                  </Button>
                </form>
              </div>
            </Modal> */}

            {/* Delete Confirmation Modal */}
            <Modal
              className={classes.modal}
              open={showDeleteModal}
              onClose={closeDeleteModal}
            >
              <div className={classes.paper}>
                <h2 id="delete-confirmation-modal">Confirm Delete</h2>
                <p id="confirm-delete-organization">
                  Are you sure you want to delete this Resource Group?
                </p>
                {deleteResourceGroupError && (
                  <Alert className="mt-3 mb-0" color="danger">
                    Error while deleting a resource group.
                    {JSON.stringify(deleteResourceGroupError)}
                  </Alert>
                )}
                <div className={classes.modalButtons}>
                  <Button
                    onClick={handleDeleteConfirm}
                    color="secondary"
                    variant="contained"
                    disabled={props.isDeletingResourceGroup}
                  >
                    Delete
                  </Button>
                  <Button
                    onClick={closeDeleteModal}
                    color="primary"
                    variant="contained"
                    style={{ margin: "10px 10px", alignSelf: "flex-end" }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </Modal>
          </div>
        ) : (
          <div>
            <h1>Not Authorized</h1>
          </div>
        )
      }
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    isGettingResourceGroups,
    getResourceGroupsMessage,
    getResourceGroupsError,

    isAddingResourceGroup,
    addResourceGroupMessage,
    addResourceGroupError,

    isEditingResourceGroup,
    editResourceGroupMessage,
    editResourceGroupError,

    isDeletingResourceGroup,
    deleteResourceGroupError,
    deleteResourceGroupMessage,

    resourceGroups,
  } = state.resourceGroup;
  return {
    isGettingResourceGroups,
    getResourceGroupsMessage,
    getResourceGroupsError,

    isAddingResourceGroup,
    addResourceGroupMessage,
    addResourceGroupError,

    isEditingResourceGroup,
    editResourceGroupMessage,
    editResourceGroupError,

    isDeletingResourceGroup,
    deleteResourceGroupError,
    deleteResourceGroupMessage,

    resourceGroups,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getResourceGroups: () => {
      dispatch(getResourceGroups());
    },
    addResourceGroup: (resourceGroup) => {
      dispatch(addResourceGroup(resourceGroup));
    },
    editResourceGroup: (resourceGroup) => {
      dispatch(editResourceGroup(resourceGroup));
    },
    deleteResourceGroup: (resourceGroupName, orgCode) => {
      dispatch(deleteResourceGroup(resourceGroupName, orgCode));
    },
    clearAllMessages: () => {
      dispatch(clearAllResourceGroupMessages());
    },
    // getListOfAccts: () => {
    //   dispatch(getListOfAccts());
    // },
    getListOfOrgsAndAccts: () => {
      dispatch(getListOfOrgsAndAccts());
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResourceGroupsConfig);
